const AbstractResourceController = require("../common/AbstractResourceController");
const FavouritesListView = require("./FavouritesListView");
const AddFavouritesView = require("./AddFavouritesView");
const RemoveFavouritesView = require("./RemoveFavouritesView");
const Utils = require("../common/Utils");

/**
 * @class
 * @extends {AbstractResourceController}
 * @constructor
 */
function FavouritesController() {
    AbstractResourceController.call(this);
    const self = this;
    const delegateControllers = {};

    let mode;

    this.checkForPrerequisites = function(id) {
        const resource = CudaLaunch.models.resources.getResource(id);
        const delegate = delegateControllers[resource.type];

        if (delegate) {
            delegate.checkForPrerequisites(id);
        } else {
            console.error("Failed to launch resource '" + resource.name + "' : no appropriate controller found.");
        }
    };

    const listView = new FavouritesListView(this.checkForPrerequisites);
    const addView = new AddFavouritesView();
    const removeView = new RemoveFavouritesView();

    /**
     * @override
     * @inheritsDoc
     */
    this.getId = function() {
        return "FavouritesController";
    };

    self.subscribeTo("add-favourites", function(data) {
        self.addFavourites(data.resources, self.showPreviousView, failCallback);
    });

    self.subscribeTo("remove-favourites", function(data) {
        self.removeFavourites(data.resources, self.showPreviousView, failCallback);
    });

    self.subscribeTo("show-add-view", function() {
        self.showAddView();
    });

    self.subscribeTo("show-remove-view", function() {
        self.showRemoveView();
    });

    self.subscribeTo("set-resource-favourite-state", function(data) {
        if (data.state) {
            CudaLaunch.models.resources.removeFavorites([data.id], null, null);
        } else {
            CudaLaunch.models.resources.addFavorites([data.id], null, null);
        }
    });

    self.subscribeToChannel("Electron", "show-favourites-view", function() {
        self.showView(listView);
    });

    const failCallback = function(message) {
        CudaLaunch.controllers.RootController.showErrorDialog(message, false, "#" + $(this).attr("id")); // TODO get correct reference
    };

    const super_filterResources = this.filterResources;

    /**
     * @override
     * @inheritDoc
     */
    this.filterResources = function(resourceItems) {
        const prefilteredResources = super_filterResources.call(this, resourceItems);
        return (Utils.objectFilter(prefilteredResources, function(resource) {
            if (resource.favouritable !== false) {
                return resource.favourite;
            }
            return false;
        }) || []);
    };

    this.toggleTabVisibility = function(resources) {
        // Favourites tab should be always visible
    };

    this.setResourcesView(listView);

    /**
     * @override
     * @inheritDoc
     */
    this.getViews = function() {
        return [listView, addView, removeView];
    };

    /**
     * @override
     * @return {Array.<string>}
     */
    this.getResourceTypes = function() {
        return Object.keys(delegateControllers);
    };

    /**
     * The favourites controller uses delegate controllers
     * to render and launch those resources it displays
     * @param {AbstractResourceController} controller
     */
    this.addDelegateController = function(controller) {
        if (controller instanceof AbstractResourceController) {
            controller.getResourceTypes().forEach(function(type) {
                delegateControllers[type] = controller;
            });

            const renderers = controller.getResourcesView().getRenderers();
            Object.keys(renderers).forEach(function(key) {
                listView.addRenderer(key, renderers[key]);
                addView.addRenderer(key, renderers[key]);
                removeView.addRenderer(key, renderers[key]);
            });
        }
    };

    /**
     * Display the Add Favourites View
     */
    this.showAddView = function() {
        mode = "add";
        self.showView(addView);

        CudaLaunch.models.resources.getGuaranteedResources()
            .done(function(resourceItems) {
                const prefilteredResources = super_filterResources.call(this, resourceItems);
                const res = Utils.objectFilter(prefilteredResources, function(e) {
                    if (e.favouritable !== false) {
                        return !e.favourite;
                    }
                    return false;
                }) || [];
                addView.renderListview(res);
            });
    };

    /**
     * Display the Remove Favourites View
     */
    this.showRemoveView = function() {
        mode = "remove";
        self.showView(removeView);

        CudaLaunch.models.resources.getGuaranteedResources()
            .done(function(resourceItems) {
                const prefilteredResources = super_filterResources.call(this, resourceItems);
                const res = Utils.objectFilter(prefilteredResources, function(e) {
                    if (e.favouritable !== false) {
                        return e.favourite;
                    }
                    return false;
                }) || [];
                removeView.renderListview(res);
            });
    };

    /**
     * Store the newly favourited items
     * @param resources {Array.<string>} the indexes of the resources that need to be favourites
     * @param onSuccess {function} success callback
     * @param onFailure {function} failure callback
     */
    this.addFavourites = function(resources, onSuccess, onFailure) {
        CudaLaunch.models.resources.addFavorites(resources, onSuccess, onFailure);
    };

    /**
     * Store the newly unfavourited items
     * @param resources {Array.<string>} the indexes of the resources are no longer favourites
     * @param onSuccess {function} success callback
     * @param onFailure {function} failure callback
     */
    this.removeFavourites = function(resources, onSuccess, onFailure) {
        CudaLaunch.models.resources.removeFavorites(resources, onSuccess, onFailure);
    };

    /**
     * @override
     */
    this.getState = function() {
        return (mode) ? {mode : mode} : undefined;
    };

    /**
     * @override
     * @param state
     */
    this.setState = function(state) {
        if (state.mode === "add") {
            self.showAddView();
        } else if (state.mode === "remove") {
            self.showRemoveView();
        }
    };

    const super_showView = this.showView;

    /**
     * @override
     * @param view
     */
    this.showView = function(view) {
        super_showView.call(this, view);
        mode = undefined;
    };
}

Utils.inherits(FavouritesController, AbstractResourceController);

module.exports = FavouritesController;